import { ButtonGroup } from "devextreme-react/button-group";
import includes from "lodash/includes";
import isNumber from "lodash/isNumber";
import styled from "styled-components";
export default {
    ButtonGroup: styled(ButtonGroup).withConfig({
        shouldForwardProp: (prop) => !includes([
            "backgroundColor",
            "color",
            "iColor",
            "hoverBackground",
            "hoverColor",
            "hoverIColor",
            "activeBackground",
            "activeColor",
            "activeIColor",
            "selectedBackground",
            "selectedColor",
            "selectedIColor",
            "fontSize",
            "iconFontSize",
            "height"
        ], prop)
    }) `
    .dx-buttongroup-wrapper {
      ${({ theme, backgroundColor }) => `background-color: ${theme[backgroundColor] || backgroundColor};`}

      border-radius: ${({ theme }) => theme["border-radius-base"]} !important;
    }
    .dx-button.dx-buttongroup-item {
      padding: 0px ${({ theme }) => theme["grid-gap-xs"]};
      ${({ height }) => height && `height: ${height}px;`}
      max-height: 100%;
      border: 0;
      &:not(.dx-state-active):not(.dx-state-hover):not(.dx-item-selected),
      &.dx-state-disabled {
        ${({ theme, backgroundColor }) => `background-color: ${theme[backgroundColor] || backgroundColor} !important;`}
      }
      ${({ fontSize }) => (isNumber(fontSize) ? `font-size: ${fontSize}px !important;` : "")}

      .w-100 {
        display: flex;
        align-items: center;
        > span {
          ${({ fontSize }) => (isNumber(fontSize) ? `font-size: ${fontSize}px !important;` : "")}
        }
      }
      color: ${({ theme, color }) => theme[color] || color} !important;
      border-radius: ${({ theme }) => theme["border-radius-base"]} !important;
      i,
      i:before {
        ${({ iconFontSize }) => isNumber(iconFontSize) ? `font-size: ${iconFontSize}px !important;` : ""}
        color: ${({ theme, iColor }) => theme[iColor] || iColor} !important;
      }

      &.dx-state-hover {
        background-color: ${({ theme, hoverBackground }) => theme[hoverBackground] || hoverBackground} !important;
        color: ${({ theme, hoverColor }) => theme[hoverColor] || hoverColor} !important;
        i {
          color: ${({ theme, hoverIColor }) => theme[hoverIColor] || hoverIColor} !important;
        }
      }

      &.dx-state-active {
        background-color: ${({ theme, activeBackground }) => theme[activeBackground]} !important;
        color: ${({ theme, activeColor }) => theme[activeColor]} !important;
        i,
        i:before {
          color: ${({ theme, activeIColor }) => theme[activeIColor]} !important;
        }
      }

      &.dx-item-selected {
        background-color: ${({ theme, selectedBackground }) => theme[selectedBackground] || selectedBackground} !important;
        color: ${({ theme, selectedColor }) => theme[selectedColor]} !important;
        i,
        i:before {
          color: ${({ theme, selectedIColor }) => theme[selectedIColor]} !important;
        }
      }
    }
  `
};
